import { Box } from '@mui/material';
import React from 'react';

import { PageContent } from '../index';

interface ITableEmptyStateWrapperProps {
  children: React.ReactNode;
}

export const TableEmptyStateWrapper: React.FC<ITableEmptyStateWrapperProps> = ({ children }) => {
  return (
    <PageContent>
      <Box
        sx={{
          width: '100%',
          flex: 1,
          minHeight: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          pt: 4,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            width: '100%',
            maxWidth: 600,
          }}
        >
          {children}
        </Box>
      </Box>
    </PageContent>
  );
};
